import { IconCrossedTools } from '@components/icons/icon-crossed-tools';
import SwitchToggle from '@components/switch-toggle/switch-toggle';
import { useDevMode } from '@hooks/use-dev-mode/use-dev-mode';
import classNames from 'classnames';

import { Props } from './dev-mode-toggle.type';

// Internal tooling (B2B-2341): hardcoded English, like every other dev-mode string.
const LABEL = 'Dev mode';

/**
 * The sidebar switch for dev mode. Renders nothing unless the PostHog flag makes dev mode
 * available to this user, so the sidebar is unchanged for everyone else. Sits next to
 * `DarkModeToggle`, which it mirrors.
 */
export const DevModeToggle = ({ className }: Props) => {
  const { isAvailable, isOn, toggleDevMode } = useDevMode();

  if (!isAvailable) return null;

  return (
    <div className={classNames('flex items-center gap-1', className)} data-testid='dev-mode-toggle'>
      <IconCrossedTools className='h-4 w-4 text-tertiary' aria-hidden />
      {/*
       * No knob icon: with only an `activeIcon` the knob was blank while dev mode was off, unlike
       * `DarkModeToggle` beside it which has one for each state. There is no natural "dev mode off"
       * glyph to pair, and the leading icon already identifies the switch.
       */}
      <SwitchToggle active={isOn} onToggleSwitch={toggleDevMode} ariaLabel={LABEL} loading={false} />
    </div>
  );
};
